import React from "react";

export const ROLES: Record<string, string> = {
  ADMIN: "Администратор", OFFICE_LEAD: "Руководитель офиса", MANAGER: "Менеджер", SENIOR_OFFICE: "Старший офиса",
  ACCOUNTANT: "Бухгалтер", TECHNICIAN: "Техник", CASHIER: "Кассир",
};
export const KIND: Record<string, string> = { bonus: "Премия", fine: "Штраф", advance: "Аванс", payout: "Выплата" };
const MONTHS = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];

export const fmtN = (n: number) => new Intl.NumberFormat("ru-RU").format(Math.round(n || 0));
export const fmt = (n: number) => fmtN(n) + " ₸";
const dayFmt = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Almaty" });
export const dayKey = (v: string | Date) => dayFmt.format(new Date(v));
export const curMonth = () => dayKey(new Date()).slice(0, 7);
export const shiftMonth = (m: string, d: number) => {
  const [y, mm] = m.split("-").map(Number);
  const t = y * 12 + (mm - 1) + d;
  return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`;
};
export const monthLabel = (m: string) => {
  const [y, mm] = m.split("-").map(Number);
  return `${MONTHS[mm - 1]} ${y}`;
};
export const dayLabel = (d: string) =>
  new Date(d + "T12:00:00").toLocaleDateString("ru-RU", { day: "numeric", month: "long", weekday: "short" });
export const fmtPhone = (p?: string | null) => {
  const d = String(p ?? "").replace(/\D/g, "");
  if (d.length === 11 && (d[0] === "7" || d[0] === "8")) return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9)}`;
  return p || "—";
};
export const fmtBirth = (v?: string | null) => {
  const m = String(v ?? "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : v || "—";
};
export const errText = (e: any, fallback = "Не удалось выполнить действие") => {
  const m = e?.response?.data?.message;
  if (Array.isArray(m)) return m.join(". ");
  if (typeof m === "string" && m) return m;
  if (e?.response?.status === 403) return "Нет доступа";
  if (!e?.response) return "Нет связи с сервером, попробуйте ещё раз";
  return fallback;
};
export const digits = (v: string) => v.replace(/[^0-9]/g, "");

export function Stat({ label, value, tone, sub }: { label: string; value: string; tone?: "accent" | "good" | "warn"; sub?: string }) {
  return (
    <div className={`cb-stat ${tone ?? ""}`}>
      <div className="cb-stat-label">{label}</div>
      <div className="cb-stat-value">{value}</div>
      {sub && <div className="cb-stat-sub">{sub}</div>}
    </div>
  );
}

export function Bar({ pct }: { pct: number }) {
  const w = Math.max(0, Math.min(100, pct));
  return <div className="cb-bar"><div className={`cb-bar-fill ${pct >= 100 ? "done" : ""}`} style={{ width: `${w}%` }} /></div>;
}

/** Кольцо выполнения плана */
export function Ring({ pct, label, sub }: { pct: number; label: string; sub: string }) {
  const r = 38, c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, pct));
  return (
    <div className="cb-ring">
      <svg viewBox="0 0 96 96" width="96" height="96" aria-hidden="true">
        <circle cx="48" cy="48" r={r} fill="none" stroke="var(--cb-line)" strokeWidth="9" />
        <circle cx="48" cy="48" r={r} fill="none" stroke={pct >= 100 ? "#34d399" : "#818cf8"} strokeWidth="9" strokeLinecap="round"
          strokeDasharray={`${(p / 100) * c} ${c}`} transform="rotate(-90 48 48)" />
        <text x="48" y="53" textAnchor="middle" className="cb-ring-text">{pct}%</text>
      </svg>
      <div>
        <div className="cb-ring-label">{label}</div>
        <div className="cb-ring-sub">{sub}</div>
      </div>
    </div>
  );
}

export function Banner({ kind, children, onClose }: { kind: "ok" | "err"; children: React.ReactNode; onClose?: () => void }) {
  return (
    <div className={`cb-banner ${kind}`} role={kind === "err" ? "alert" : "status"}>
      <span>{children}</span>
      {onClose && <button type="button" onClick={onClose} aria-label="Закрыть">✕</button>}
    </div>
  );
}

export function Avatar({ url, first, last, size = 64 }: { url?: string | null; first?: string; last?: string; size?: number }) {
  const ini = ((last?.[0] ?? "") + (first?.[0] ?? "")).toUpperCase() || "?";
  return (
    <div className="cb-avatar" style={{ width: size, height: size, fontSize: size * 0.36 }}>
      {url ? <img src={url} alt="Фото профиля" /> : <span aria-hidden="true">{ini}</span>}
    </div>
  );
}

export function Section({ title, children, right }: { title: string; children: React.ReactNode; right?: React.ReactNode }) {
  return (
    <section className="cb-section">
      <div className="cb-section-head"><h3>{title}</h3>{right}</div>
      {children}
    </section>
  );
}
